import axios from 'axios';

export async function getPlayersMoto() {
  const res = await axios({
    method: 'GET',
    url: process.env.REACT_APP_API_URL + '/api/configuration/moto_sentences/',
  });

  if (res.status === 200) {
    return res.data;
  } else {
    return { error: res.status };
  }
}

